const KEY = "ceramixa_offline_queue";

export function getQueue() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

function setQueue(q) {
    localStorage.setItem(KEY, JSON.stringify(q));
    window.dispatchEvent(new CustomEvent("offline-queue-changed", { detail: q.length }));
}

export function enqueue(item) {
    const q = getQueue();
    q.push(item);
    setQueue(q);
}

let flushing = false;

export async function flushQueue() {
    if (flushing) return { synced: 0, remaining: getQueue().length };
    flushing = true;
    try {
        let q = getQueue();
        if (q.length === 0) return { synced: 0, remaining: 0 };
        const api = (await import("./api")).default;
        let synced = 0;
        while (q.length > 0) {
            const item = q[0];
            try {
                const data = typeof item.data === "string" ? JSON.parse(item.data) : item.data;
                await api.post(item.url, data, { _replay: true });
                synced += 1;
                q = q.slice(1);
                setQueue(q);
            } catch (e) {
                if (e.response) {
                    q = q.slice(1);
                    setQueue(q);
                } else {
                    break;
                }
            }
        }
        return { synced, remaining: getQueue().length };
    } finally {
        flushing = false;
    }
}
